const images = import.meta.glob(
    './**/*.{avif,gif,heif,jpeg,jpg,png,tiff,webp,svg}',
    {
        eager: true,
        query: {
            enhanced: true,
            quality: 100,
            w: '40'
        }
    }
)
export const authorsImagesMap = Object.entries(images).reduce(
    (map, [pathname, module]) => {
        pathname = pathname.slice(2, pathname.lastIndexOf("."))
        map[pathname] = module
        return map
    },
    {} as Record<string, any>
)